export const CONTACT_EMAIL = 'gfxsouls@gmail.com';

// This public form endpoint is safe to ship in the browser bundle.
export const CONTACT_ENDPOINT = process.env.REACT_APP_FORMSPREE_ENDPOINT || 'https://formspree.io/f/xvkkqpbl';
